import { render, staticRenderFns } from "./Ordendeservicios.vue?vue&type=template&id=0f3237ae"
import script from "./Ordendeservicios.vue?vue&type=script&lang=js"
export * from "./Ordendeservicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports